import CategoriesContainer from '../components/CategoryiesContainer';
import Header from '../components/Header';

const Categories = () => (
  <>
    <Header />
    <CategoriesContainer />
  </>
);

export default Categories;
